import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import axios from "axios";
import { BasedURL } from "../util/constants";
import NavBar from "./NavBar";
import Footer from "./Footer";

export default function LeadershipDetail() {
  const { id } = useParams();
  const history = useHistory();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    axios
      .get(`${BasedURL}/leadership/${id}`)
      .then((r) => setItem(r.data))
      .catch(() => setItem(null))
      .finally(() => setLoading(false));
  }, [id]);

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <NavBar />
      <main className="flex-1 max-w-3xl mx-auto w-full px-4 py-12">
        {loading && <p className="text-gray-400 text-sm">Loading…</p>}

        {!loading && !item && (
          <div className="text-center py-20">
            <p className="text-gray-500 text-lg mb-6">Page not found.</p>
            <button onClick={() => history.push("/")} className="text-green-700 font-semibold underline bg-transparent border-0 cursor-pointer">
              Back to home
            </button>
          </div>
        )}

        {item && (
          <>
            <button
              onClick={() => history.goBack()}
              className="text-sm text-gray-500 hover:text-gray-800 mb-8 flex items-center gap-1 bg-transparent border-0 cursor-pointer p-0"
            >
              ← Back
            </button>

            {item.imageUrl && (
              <img
                src={item.imageUrl}
                alt={item.title}
                className="w-full rounded-xl object-cover mb-8"
                style={{ maxHeight: 400 }}
              />
            )}

            <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">{item.title}</h1>

            {item.subtitle && (
              <p className="text-gray-500 text-base mb-6">{item.subtitle}</p>
            )}

            {item.content && (
              <div className="text-gray-700 text-base leading-relaxed whitespace-pre-wrap">
                {item.content}
              </div>
            )}
          </>
        )}
      </main>
      <Footer />
    </div>
  );
}
